{
  "R": [0, 85, 0, 0, 0, 0, 0, 0, 85, 255, 255, 255, 172],
  "G": [0, 0, 0, 0, 85, 170, 255, 255, 255, 255, 85, 0, 0],
  "B": [0, 170, 85, 255, 255, 170, 170, 0, 85, 0, 0, 0, 0],
  "A": [0, 5, 10, 21, 26, 32, 37, 42, 48, 53, 64, 72, 85],
  "I": [0, 15, 31, 63, 79, 95, 111, 127, 143, 159, 191, 217, 255]
}
